export default {
  container: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  },
  digitContainer: {
    // margin: "8px",
    height: "40px",
    width: "35px",
    border: "1px solid #707070",
    borderRadius: "10px",
    textAlign: "center",
    outline: "none",
  },
  cntentBox: {
    borderRadius: "10px",
    backgroundColor: "#FFFFFF",
  },

  headingText: {
    color: "#8C8C8C",
    fontSize: "20px",
    fontWeight: "400",
  },
  subheadingText: {
    color: "#8C8C8C",
    fontSize: "16px",
    fontWeight: "400",
    paddingTop: "20px",
    paddingBottom: "16px",
  },
  submitButton: {
    backgroundColor: "#043D90",
    width: "100%",
    height: "40px",
    marginTop: 30,
  },
  OtpAgainText: {
    textAlign: "right",
    color: "#183053",
    fontSize: "12px",
    paddingTop: "16px",
  },
};
